// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_tool_tool_module_ts":"2bad02899ee02988","src_app_pages_error_error_module_ts":"b41940c845967c77"}[chunkId] + ".js";
};